import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationModel } from '@app/models/system-settings';

@Injectable()
export class NotificationService {
	endpointBase = '/api/notification-type';

	constructor(private readonly http: HttpClient) {}

	getList(): Observable<any> {
		return this.http.get(this.endpointBase);
	}

	update(entities: NotificationModel[]): Observable<any> {
		return this.http.put(this.endpointBase, entities);
	}

	updateNotification(notification: NotificationModel): Observable<any> {
		return this.http.put(`${this.endpointBase}/${notification.Id}`, notification);
	}
}
